import { createSelector } from 'reselect';
import TrackedItemsInPredesSummaryColumns
  from '../../containers/TrackedItemsInPredesSummaryColumns';
import ReportDefinitions from '../../../../../common/config/ReportDefinitions';

export const getGeneratedOnDateTime =
  state => state.reporting.TRACKED_ITEMS_IN_PREDES_SUMMARY
    .metadata.generatedOnDateTime;

export const getIsLoading =
  state => state.reporting.TRACKED_ITEMS_IN_PREDES_SUMMARY.isLoading;

export const getData =
  ReportDefinitions.TRACKED_ITEMS_IN_PREDES_SUMMARY.getDataFunction();

export const getColumns =
  createSelector(getData, state => state.reporting.TRACKED_ITEMS_IN_PREDES_SUMMARY.requestParams, TrackedItemsInPredesSummaryColumns);
